<h5 class="a-modal-title">
  {{'modal.cancel.subscription.title' | translate}}
</h5>
<form [formGroup]="cancelReasonsForm">
  <ng-select formControlName="reason" [placeholder]="'modal.cancel.subscription.select.placeholder' | translate" [notFoundText]="'ng-select.notFoundText' | translate" class="input-select_select">
    <ng-option *ngFor="let reason of cancelReasons" [value]="reason.id">{{reason.name}}</ng-option>
  </ng-select>
  <p class="a-modal-text">
    {{'modal.cancel.subscription.content' | translate}}
  </p>
  <div class="a-modal-button">
    <button class="a-button-ok"
            type="submit"
            (click)="onSubmit(cancelReasonsForm.value)"
            [innerHtml]="modalData?.submitBtnText | translate"
            [disabled]="!submitReady"
    >
    </button>
    <button class="a-button-cancel"
            *ngIf="modalData?.hidePopupBtn"
            (click)="hideFunc($event)"
            [innerHtml]="modalData?.hidePopupBtnText | translate">
    </button>
  </div>
</form>
